"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState;

  // =============================================================================================
  // DEFIB SIM — the start-screen tab. Pick a scenario (or free play, or a custom stepped scenario),
  // Education or Assessment, and optionally the patient's age/weight so paediatric energies apply.
  // The learner runs the defibrillator on a tablet (Join -> Defibrillator QR code); the
  // facilitator gets the Defib controller. Everything else (engine, session, debrief) is shared.
  // =============================================================================================
  var DefibSimSetup = function DefibSimSetup(_ref) {
    var onStart = _ref.onStart;
    var _window = window,
      Button = _window.Button,
      Lucide = _window.Lucide,
      validateBuilderField = _window.validateBuilderField,
      BUILDER_LIMITS = _window.BUILDER_LIMITS;
    var D = window.DefibSim;
    var RG = window.RHYTHMS;
    var _useState = useState('education'),
      _useState2 = _slicedToArray(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];
    var _useState3 = useState('vf-arrest'),
      _useState4 = _slicedToArray(_useState3, 2),
      choice = _useState4[0],
      setChoice = _useState4[1];
    var _useState5 = useState('40'),
      _useState6 = _slicedToArray(_useState5, 2),
      age = _useState6[0],
      setAge = _useState6[1];
    var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      weight = _useState8[0],
      setWeight = _useState8[1];
    var _useState9 = useState('Male'),
      _useState0 = _slicedToArray(_useState9, 2),
      sex = _useState0[0],
      setSex = _useState0[1];
    var _useState1 = useState([{
        rhythm: 'VF',
        trigger: 'shock'
      }, {
        rhythm: 'Sinus Rhythm',
        trigger: 'analyse'
      }]),
      _useState10 = _slicedToArray(_useState1, 2),
      steps = _useState10[0],
      setSteps = _useState10[1];
    var _useState11 = useState(function () {
        return D.savedNames();
      }),
      _useState12 = _slicedToArray(_useState11, 2),
      saved = _useState12[0],
      setSaved = _useState12[1];
    var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      savedSel = _useState14[0],
      setSavedSel = _useState14[1];
    var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      note = _useState16[0],
      setNote = _useState16[1];
    var fileRef = React.useRef(null);
    var ageError = age === '' ? null : validateBuilderField('age', age);
    var weightError = weight === '' ? null : validateBuilderField('weight', weight);
    var stepsValid = choice !== 'custom' || !!D.normaliseSteps(steps);
    var invalid = !!(ageError || weightError) || !stepsValid;
    var fieldClass = function fieldClass(err) {
      return "w-full bg-slate-900 border rounded p-2 text-white ".concat(err ? 'border-red-500' : 'border-slate-600');
    };
    var groups = [];
    D.SCENARIOS.forEach(function (s) {
      var g = groups.find(function (x) {
        return x.name === s.group;
      });
      if (!g) {
        g = {
          name: s.group,
          items: []
        };
        groups.push(g);
      }
      g.items.push(s);
    });
    var setStep = function setStep(i, key, value) {
      return setSteps(steps.map(function (s, j) {
        return j === i ? _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, key, value)) : s;
      }));
    };
    var flash = function flash(text) {
      var kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ok';
      setNote({
        text: text,
        kind: kind
      });
      setTimeout(function () {
        return setNote(null);
      }, 4000);
    };
    var saveSteps = function saveSteps() {
      var clean = D.normaliseSteps(steps);
      if (!clean) {
        flash('Add at least one step first.', 'err');
        return;
      }
      var name = (window.prompt('Name for this scenario:') || '').trim();
      if (!name) return;
      if (D.savedNames().indexOf(name) !== -1 && !window.confirm("Replace the saved scenario \"".concat(name, "\"?"))) return;
      if (D.save(name, clean)) {
        setSaved(D.savedNames());
        setSavedSel(name);
        flash("Saved \"".concat(name, "\" in this browser."));
      } else flash('Could not save in this browser (storage unavailable). Use Export instead.', 'err');
    };
    var loadSteps = function loadSteps() {
      var s = savedSel && D.loadSaved(savedSel);
      if (s) {
        setSteps(s);
        flash("Loaded \"".concat(savedSel, "\"."));
      }
    };
    var deleteSteps = function deleteSteps() {
      if (!savedSel || !window.confirm("Delete the saved scenario \"".concat(savedSel, "\"?"))) return;
      D.remove(savedSel);
      setSaved(D.savedNames());
      setSavedSel('');
    };
    var exportSteps = function exportSteps() {
      if (!D.normaliseSteps(steps)) {
        flash('Add at least one step first.', 'err');
        return;
      }
      var blob = new Blob([D.exportText(steps)], {
        type: 'application/json'
      });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'defib-scenario.json';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () {
        return URL.revokeObjectURL(a.href);
      }, 1000);
    };
    var importSteps = function importSteps(e) {
      var file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      file.text().then(function (text) {
        var s = D.parseFile(text);
        if (!s) throw new Error('invalid');
        setSteps(s);
        flash('Scenario imported.');
      })["catch"](function () {
        return flash('That file is not a valid Defib Sim scenario.', 'err');
      });
    };
    var start = function start() {
      if (invalid) return;
      onStart({
        scenario: choice,
        mode: mode,
        steps: steps,
        age: age === '' ? 40 : Number(age),
        weight: weight === '' ? null : Number(weight),
        sex: sex
      });
    };
    var optionClass = function optionClass(on) {
      return "text-left p-3 rounded border transition-colors ".concat(on ? 'bg-sky-900/40 border-sky-400 text-white' : 'bg-slate-900 border-slate-700 text-slate-300 hover:bg-slate-800');
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 animate-fadeIn",
      "data-testid": "defib-setup"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-amber-950/30 border border-amber-700/50 rounded p-3 text-sm text-slate-300"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-amber-300 mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-4 h-4"
    }), " Defib Sim \u2014 defibrillator skills"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, "The learner uses a defibrillator on a tablet (", /*#__PURE__*/React.createElement("b", null, "Join"), " \u2192 Defibrillator QR code, or open ", /*#__PURE__*/React.createElement("span", {
      className: "font-mono"
    }, "defib/"), " with this session code). You run the scenario from the Defib controller: rhythm, shock response, CPR, drugs and the event log. Works on the same computer or remotely.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold mb-1"
    }, "Mode"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('education');
      },
      className: optionClass(mode === 'education'),
      "aria-pressed": mode === 'education'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold"
    }, "Education"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "Pulse-check results and RCUK hint cards on the defib.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('assessment');
      },
      className: optionClass(mode === 'assessment'),
      "aria-pressed": mode === 'assessment'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold"
    }, "Assessment"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "No pulse-check results or hint cards on the defib. Feedback in the debrief.")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold mb-1"
    }, "Scenario"), /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, groups.map(function (g) {
      return /*#__PURE__*/React.createElement("div", {
        key: g.name
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-xs font-bold text-slate-400 mb-1"
      }, g.name), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-2"
      }, g.items.map(function (s) {
        return /*#__PURE__*/React.createElement("button", {
          key: s.id,
          type: "button",
          "data-defib-scenario": s.id,
          onClick: function onClick() {
            return setChoice(s.id);
          },
          className: optionClass(choice === s.id),
          "aria-pressed": choice === s.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "font-bold text-sm"
        }, s.name), /*#__PURE__*/React.createElement("div", {
          className: "text-[11px] text-slate-400 line-clamp-2"
        }, s.description));
      })));
    }), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 md:grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-defib-scenario": "free",
      onClick: function onClick() {
        return setChoice('free');
      },
      className: optionClass(choice === 'free'),
      "aria-pressed": choice === 'free'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-sm"
    }, "Free play"), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400"
    }, "Starts in sinus rhythm; you change the rhythm as you go.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-defib-scenario": "custom",
      onClick: function onClick() {
        return setChoice('custom');
      },
      className: optionClass(choice === 'custom'),
      "aria-pressed": choice === 'custom'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-sm"
    }, "Custom scenario"), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400"
    }, "Up to ", D.MAX_STEPS, " rhythm steps, each moving on at a trigger you choose."))))), choice === 'custom' && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-3 space-y-2",
      "data-testid": "defib-steps"
    }, steps.map(function (s, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "grid grid-cols-[auto_1fr_1fr_auto] gap-2 items-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-xs font-bold text-sky-300 w-12"
      }, "Step ", i + 1), /*#__PURE__*/React.createElement("select", {
        "aria-label": "Step ".concat(i + 1, " rhythm"),
        value: s.rhythm,
        onChange: function onChange(e) {
          return setStep(i, 'rhythm', e.target.value);
        },
        className: "bg-slate-800 border border-slate-600 rounded p-1.5 text-sm text-white"
      }, RG.SELECTABLE.map(function (r) {
        return /*#__PURE__*/React.createElement("option", {
          key: r,
          value: r
        }, RG.labelFor(r));
      })), /*#__PURE__*/React.createElement("select", {
        "aria-label": "Step ".concat(i + 1, " trigger"),
        value: s.trigger,
        onChange: function onChange(e) {
          return setStep(i, 'trigger', e.target.value);
        },
        className: "bg-slate-800 border border-slate-600 rounded p-1.5 text-sm text-white"
      }, Object.keys(D.TRIGGERS).map(function (t) {
        return /*#__PURE__*/React.createElement("option", {
          key: t,
          value: t
        }, D.TRIGGERS[t]);
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "Remove step ".concat(i + 1),
        onClick: function onClick() {
          return setSteps(steps.filter(function (_, j) {
            return j !== i;
          }));
        },
        className: "text-red-400 hover:text-red-200 px-2"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-4 h-4"
      })));
    }), !steps.length && /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "No steps yet."), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 pt-1"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      disabled: steps.length >= D.MAX_STEPS,
      onClick: function onClick() {
        return setSteps(steps.concat([{
          rhythm: 'Sinus Rhythm',
          trigger: 'analyse'
        }]));
      },
      className: "h-8 text-xs"
    }, steps.length >= D.MAX_STEPS ? "Maximum ".concat(D.MAX_STEPS, " steps") : '+ Add step'), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Saved scenarios",
      value: savedSel,
      onChange: function onChange(e) {
        return setSavedSel(e.target.value);
      },
      className: "bg-slate-800 border border-slate-600 rounded px-2 text-xs text-white h-8"
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, saved.length ? '- Saved scenarios -' : '- None saved -'), saved.map(function (n) {
      return /*#__PURE__*/React.createElement("option", {
        key: n,
        value: n
      }, n);
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: loadSteps,
      disabled: !savedSel,
      className: "h-8 text-xs"
    }, "Load"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: saveSteps,
      className: "h-8 text-xs"
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: deleteSteps,
      disabled: !savedSel,
      className: "h-8 text-xs"
    }, "Delete"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: exportSteps,
      className: "h-8 text-xs"
    }, "Export file"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return fileRef.current && fileRef.current.click();
      },
      className: "h-8 text-xs"
    }, "Import file"), /*#__PURE__*/React.createElement("input", {
      ref: fileRef,
      type: "file",
      accept: "application/json,.json",
      hidden: true,
      onChange: importSteps,
      "data-testid": "defib-import"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400"
    }, "Saved scenarios stay in this browser. Files exported from the standalone Defib-sim import here too.")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3 gap-2"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase",
      htmlFor: "defibAge"
    }, "Age (years)"), /*#__PURE__*/React.createElement("input", {
      id: "defibAge",
      type: "number",
      min: BUILDER_LIMITS.age.min,
      max: BUILDER_LIMITS.age.max,
      value: age,
      onChange: function onChange(e) {
        return setAge(e.target.value);
      },
      className: fieldClass(ageError)
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase",
      htmlFor: "defibWeight"
    }, "Weight (kg)"), /*#__PURE__*/React.createElement("input", {
      id: "defibWeight",
      type: "number",
      min: BUILDER_LIMITS.weight.min,
      max: BUILDER_LIMITS.weight.max,
      step: "0.1",
      value: weight,
      onChange: function onChange(e) {
        return setWeight(e.target.value);
      },
      placeholder: "optional",
      className: fieldClass(weightError)
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "text-[10px] text-slate-400 uppercase",
      htmlFor: "defibSex"
    }, "Sex"), /*#__PURE__*/React.createElement("select", {
      id: "defibSex",
      value: sex,
      onChange: function onChange(e) {
        return setSex(e.target.value);
      },
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white"
    }, /*#__PURE__*/React.createElement("option", null, "Male"), /*#__PURE__*/React.createElement("option", null, "Female")))), (ageError || weightError) && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-red-400"
    }, ageError || weightError), note && /*#__PURE__*/React.createElement("div", {
      role: "status",
      className: "text-xs ".concat(note.kind === 'err' ? 'text-red-300' : 'text-emerald-300')
    }, note.text), /*#__PURE__*/React.createElement(Button, {
      onClick: start,
      disabled: invalid,
      className: "w-full py-4 text-lg ".concat(invalid ? 'opacity-40 cursor-not-allowed' : '')
    }, "Start Defib Sim"));
  };
  window.DefibSimSetup = DefibSimSetup;
})();